import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { mergeRegister } from "@lexical/utils";
import { COMMAND_PRIORITY_EDITOR } from "lexical";
import { useEffect } from "react";
import { $createVideoNode } from "../nodes/video-node-mui";
import { INSERT_VIDEO_COMMAND } from "../types/commands";
import { $insertNode } from "../utils/insert-node";

import type { FC } from "react";

export const VideoPlugin: FC = (): null => {
  const [editor] = useLexicalComposerContext();

  useEffect(
    () =>
      mergeRegister(
        editor.registerCommand(
          INSERT_VIDEO_COMMAND,
          ({ videoUrl, thumbnailUrl, aspect, sourceAssetId, proportionOfMaxWidth, title }) => {
            $insertNode(
              $createVideoNode(
                editor._headless,
                videoUrl,
                thumbnailUrl,
                aspect,
                proportionOfMaxWidth,
                sourceAssetId,
                title,
              ),
            );
            return true;
          },
          COMMAND_PRIORITY_EDITOR,
        ),
      ),
    [editor],
  );

  return null;
};
